// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.openeo-vue-component.processing-parameters .row{margin-bottom:.75em}.openeo-vue-component.processing-parameters .row .styled-description{font-size:.8em;color:#666}.openeo-vue-component.processing-parameters .row .value>ol,.openeo-vue-component.processing-parameters .row .value>ul{margin:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
